// extracted by mini-css-extract-plugin
export default {"pricingDisclaimer":"hUlwnfuz7J"};